import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppComponents, PrestoAppUtils } from 'presto-mini-apps-lib';
import PageWrapper from '../../components/PageWrapper';
import {
    ButtonHeight,
    ContainerWidth,
    TOPUP_MIN_AMOUNT
} from '../../constants/appState';
import {
    term_continue,
    term_topUpCredits,
    term_topUpMinimum
} from '../../constants/text';
import connectPage from '../../scenes/Main/index';
import Routes from '../../constants/routes';
import { appService } from '../../services';
import TextInputWithLabel from '../../components/TextInputWithLabel';
import PoweredByPresto from '../../components/PoweredByPresto';


class TopUpOptions extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.TOPUP_OPTIONS;

        this.state = {
            balance: 0,
            amount: 0,
            minAmount: 1000,
            currency: '',
            formValue: {
                inputAmount: ''
            },
            optionSelected: false,
            clearField: false,
            showAmountError: false,
            submitDisabled: false,
            rewardInfo: '',
            options: [],
        }
    }

    componentDidMount() {
        const { mainProps } = this.props;
        const { topUpData } = mainProps.appState;
        const topUpAmount = topUpData.amount;
        const roundedAmount = Math.ceil(PrestoAppUtils.convertToCurrency(topUpAmount / 100).replaceAll(',', '')) * 100;
        this.setState({
            balance: topUpData.balance,
            amount: roundedAmount,
            minAmount: window && window.PrestoPayObj ? window.PrestoPayObj.minTopUp : TOPUP_MIN_AMOUNT,
            currency: mainProps.appState.curCode.currency,
            formValue: {
                ...this.state.formValue,
                inputAmount: PrestoAppUtils.convertToCurrency(roundedAmount / 100)
            }
        })

        this.fetchTopUpOptions();
    }

    fetchTopUpOptions = () => {
        const { actionHandler } = this.props;

        actionHandler.setIsLoading(true);
        appService.apiTopUpOptions({
            paymentCode: window.PrestoPayObj.paymentCode,
            onSuccess: this.onFetchOptionsSuccessHandler,
            onError: this.onFetchOptionsFailedHandler
        });
    }

    onFetchOptionsSuccessHandler = (resp) => {
        const { actionHandler } = this.props;
        const { amount } = this.state;

        actionHandler.setIsLoading(false);

        if (!!resp.success) {
            const data = resp.data;
            const options = data.topupConfigs;
            const option = options.filter((item) => (amount > 0 && item.value <= amount)).reverse();

            this.setState({
                options: options,
                rewardInfo: option[0] && option[0].displayText
            });
        }
    };

    onFetchOptionsFailedHandler = (data) => {
        const { actionHandler } = this.props;
        actionHandler.setIsLoading(false);
    };

    onGoBack = () => {
        const { actionHandler } = this.props;
        actionHandler.changePageHandler(Routes.PAYMENT);

    }

    onContinue = () => {
        const { mainProps, actionHandler } = this.props;
        const { amount } = this.state;

        const loginData = mainProps.appState.loginData;

        actionHandler.setIsLoading(true);

        appService.apiTopUpRegister({
            paymentCode: window.PrestoPayObj.paymentCode,
            authCode: window.PrestoPayObj.authCode,
            loginMethod: loginData.loginMethod,
            mobileNum: loginData.mobile.replace(/^0+/, ''),
            mobileCountryCode: (!!loginData.email && loginData.email !== '' ? '' : loginData.mobileCountryCode),
            email: loginData.email,
            password: loginData.password,
            amount: amount,
            description: term_topUpCredits,
            onSuccess: this.onTopUpRegisterSuccessHandler,
            onError: this.onTopUpRegisterFailedHandler
        });

    };

    onTopUpRegisterSuccessHandler = (resp) => {
        const { actionHandler, mainProps } = this.props;

        actionHandler.setIsLoading(false);

        if (!!resp.success) {
            actionHandler.updateTopUpData({
                ...resp.data,
                balance: mainProps.appState.topUpData.balance
            });
            actionHandler.changePageHandler(Routes.TOPUP_PAYMENT);
        }
    };

    onTopUpRegisterFailedHandler = (data) => {
        const { actionHandler } = this.props;
        actionHandler.setIsLoading(false);
    };

    onOptionSelected = (option) => {
        const value = option.value / 100;
        this.setState({
            optionSelected: true,
            amount: option.value,
            showAmountError: false,
            rewardInfo: option.displayText,
            submitDisabled: false,
            formValue: {
                ...this.state.formValue,
                inputAmount: value.toFixed(2),
            }
        })
    }

    onInputStateChangeHandler = (input, elmName) => {
        const { options, minAmount } = this.state;

        let topUpAmount = 0;
        let topUpInput = '0.00';
        if (!!input && input.length > 0) {
            const cleanInput = input.replaceAll(',', '').replaceAll('.', '');
            const val = parseFloat(cleanInput);
            topUpAmount = val;
            topUpInput = PrestoAppUtils.convertToCurrency(val / 100);
        }

        const option = options.filter((item) => (topUpAmount > 0 && item.value <= topUpAmount)).reverse();

        this.setState({
            optionSelected: false,
            amount: topUpAmount,
            formValue: {
                ...this.state.formValue,
                inputAmount: topUpInput
            },
            showAmountError: topUpAmount < minAmount,
            rewardInfo: option[0] && option[0].displayText,
            submitDisabled: (topUpAmount < minAmount) === true
        });

    };

    render() {
        const { options, currency, balance, amount, minAmount, formValue, rewardInfo, optionSelected, showAmountError, submitDisabled } = this.state;

        return (
            <React.Fragment>
                <PageWrapper containerHeight={300} showPoweredByPresto={false}>
                    <TopUpOptionsWrapper className="topup-options">
                        <div className="details">
                            <div className="title">
                                <div className="back-btn" onClick={this.onGoBack}></div>
                                <div className="label">CREDITS TOP UP</div>
                            </div>
                            <div className="balance">
                                <div className="label">Current Balance</div>
                                <div className="amount">{currency}{PrestoAppUtils.convertToCurrency(balance / 100)}</div>
                            </div>
                        </div>
                        <div className="options-selector">
                            <div className="panel-body">
                                <div className="title">Enter Amount</div>
                                <div className={!!showAmountError ? 'amount error' : 'amount'}>
                                    <TextInputWithLabel
                                        inputName="inputAmount"
                                        value={formValue.inputAmount}
                                        preText={currency}
                                        maxLength={10}
                                        inputStateChangeHandler={this.onInputStateChangeHandler}
                                    />
                                </div>
                                {!!showAmountError && (
                                    <div className="input-error">
                                        <span className="icon">
                                            <PrestoAppTheme.images.InfoIcon
                                                color={PrestoAppTheme.colors.prestoRed}
                                                textColor={PrestoAppTheme.colors.white}
                                            />
                                        </span>
                                        <span className="text">{term_topUpMinimum} {currency}{PrestoAppUtils.convertToCurrency(minAmount / 100)}.</span>
                                    </div>
                                )}
                                {rewardInfo && (
                                    <div className="info">
                                        <span className="icon">
                                            <PrestoAppTheme.images.InfoIcon
                                                color={greenColor}
                                                textColor={PrestoAppTheme.colors.white}
                                            />
                                        </span>
                                        <span className="text">{rewardInfo}</span>
                                    </div>
                                )}
                            </div>
                            <div className="panel-body option-container">
                                {options.map((item, index) => {
                                    return (
                                        <div className={'option-item ' + (optionSelected && item.value === amount ? 'selected ' : '') + (item.displayText ? 'reward ' : '')} key={index}
                                            onClick={() => this.onOptionSelected(item)}
                                        >
                                            {item.displayText && (
                                                <div className={'reward ' + (optionSelected && item.value === amount ? 'selected ' : '')}>{item.displayText}</div>
                                            )}
                                            <div className="label">
                                                <div className="currency">{currency}</div>
                                                <div className="amount">{PrestoAppUtils.convertToCurrency(item.value / 100)}</div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <SuccessActionWrapper>
                                <div className="action-area">
                                    <PrestoAppComponents.Button
                                        height={ButtonHeight+'px'}
                                        className="continue-button"
                                        disabled={submitDisabled}
                                        onClick={this.onContinue}
                                    >{term_continue}</PrestoAppComponents.Button>
                                </div>
                            </SuccessActionWrapper>

                            <PoweredByPresto />
                        </div>
                    </TopUpOptionsWrapper>
                </PageWrapper>
            </React.Fragment>
        );
    }
}

export default connectPage(TopUpOptions);

const iconSize = '16px';
const greenColor = '#09C199';
const TopUpOptionsWrapper = styled.div`
    min-height: 200px;
    font-size: .875rem;

    & .details {
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: ${PrestoAppTheme.colors.baseGreyDark};
        padding-bottom: 3.125rem; 
        background: url("/resources/images/topup-options-bg.png") right center / 160px no-repeat;

        & .title {
            display: flex;
            align-items: center;
            margin: ${PrestoAppTheme.layout.smallGap};

            & .back-btn {
                border: solid ${PrestoAppTheme.colors.baseGreyDark};
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
                width: 3px;
                height: 3px;
                transform: rotate(135deg);
                cursor: pointer;
            }

            & .label { 
                flex-grow: 1;
                text-align: center;
                text-transform: uppercase;
                font-size: ${PrestoAppTheme.layout.fontSizeStandard};
                font-weight: 400;
            }
        }

        & .balance {
            margin: ${PrestoAppTheme.layout.smallGap};

            & > .amount {
                font-size: 1.75rem;
                font-weight: 500;
            }
            
            & > .label {
                font-weight: 400;
            }
        }
    }

    & .options-selector {
        min-height: 100px;
        background-color: #FEF3E2;
        margin-top: -4.063rem;
        border-radius: 10px 10px ${PrestoAppTheme.layout.borderRadius} ${PrestoAppTheme.layout.borderRadius};
        padding-bottom: ${PrestoAppTheme.layout.smallGap};

        & .panel-body {
            padding: 0.5rem 0 0 0;
            text-align: left;
            box-sizing: border-box;
            flex: 3;
            font-weight: 400;
            font-size: .875rem;
            margin: ${PrestoAppTheme.layout.smallGap}; 

            &.option-container {
                display: flex;
                flex-wrap: wrap;
                flex-direction: row;
                padding: 0; 
                margin: ${PrestoAppTheme.layout.smallGap}; 
            }

            & .info {
                display: flex;
                align-items: center;
                margin-top: ${PrestoAppTheme.layout.smallGap};
                justify-content: space-around;
                color: ${greenColor};
                font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
                font-weight: 400;

                & .icon {
                    display: inline-block;
                    height: ${iconSize};
                    width: ${iconSize};
                    margin-top: 0.125rem;
                    border: 1px solid ${greenColor};
                    border-radius: 100%;
                }

                & .text {
                    display: inline-block;
                    width: calc(100% - ${iconSize} - ${PrestoAppTheme.layout.smallGap});
                }
            }

            & .input-error {
                display: flex;
                align-items: center;
                margin-top: ${PrestoAppTheme.layout.smallGap};
                justify-content: space-around;
                color: ${PrestoAppTheme.colors.prestoRed};
                font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
                font-weight: 400;

                & .icon {
                    display: inline-block;
                    height: ${iconSize};
                    width: ${iconSize};
                    margin-top: 0.125rem;
                    border: 1px solid ${PrestoAppTheme.colors.prestoRed};
                    border-radius: 100%;
                }

                & .text {
                    display: inline-block;
                    width: calc(100% - ${iconSize} - ${PrestoAppTheme.layout.smallGap});
                }
            }
            
            & .option-item {
                display: flex; 
                width: calc(50% - 10px);
                justify-content: flex-end;
                flex-direction: column;
                background-color: ${PrestoAppTheme.colors.white};
                border-radius: ${PrestoAppTheme.layout.borderRadius};
                box-shadow: ${PrestoAppTheme.layout.boxShadow};
                margin: 5px;
                cursor: pointer;

                &.reward {
                    margin: 10px 5px 5px 5px;

                    & .label {
                        margin: 0 ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap};
                    }
                }

                &.selected {
                    border: 1px solid ${greenColor};
                    width: calc(50% - 12px);
                }
            
                & .label {
                    display: flex;
                    flex-direction: row;
                    margin: ${PrestoAppTheme.layout.smallGap}; 
                    align-items: flex-end;

                    & .amount {
                        font-weight: 500;
                        font-size: ${PrestoAppTheme.layout.fontSizeStandard};
                    }
                }
                
                & .value {
                    font-weight: 400;
                }

                & .reward {
                    position: relative;
                    top: -10px;
                    background-color: ${greenColor};
                    width: fit-content;
                    max-width: calc(100% - 20px);
                    padding: 2px 6px; 
                    border-radius: ${PrestoAppTheme.layout.borderRadius} 0 ${PrestoAppTheme.layout.borderRadius} 0;
                    font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
                    overflow: hidden;
                    max-height: 80px;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    color: ${PrestoAppTheme.colors.white};

                    &.empty {
                        background-color: transparent;
                    }
                    
                    &.selected {
                        margin-left: -1px;
                    }
                }
            }
            
            & .pre-text {
                width: ${PrestoAppTheme.layout.largeGap};
                font-weight: 500;
            }

            & .amount {

                &.error {
                    color: ${PrestoAppTheme.colors.prestoRed};

                    & input {
                        color: ${PrestoAppTheme.colors.prestoRed};
                    }
                }
                
                & .additional-info {
                    font-weight: 400;
                    text-align: right;
                }
                
                & .error-message {
                    line-height: 1.2rem;
                }
                
                & input {
                    font-weight: 500;
                    text-align: left;
                }
            }

        }
    }
`;

const SuccessActionWrapper = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    max-width: ${ContainerWidth}px;
    margin: ${PrestoAppTheme.layout.smallGap} auto;

    & .action-area {
        padding: ${PrestoAppTheme.layout.smallGap} 0;

        & .continue-button {
            &[disabled] {
                background-color: rgba(${PrestoAppTheme.colors.prestoRedRGB}, .4);
            }
        }
    }
`;